<template>
  <div
    :class="[
      'absolute p-4 rounded-lg text-white z-50',
      positionClass,
      backgroundClass,
    ]"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'BaseToast',
  components: {},
  props: {
    position: {
      type: String,
      default: 'upper-right',
      validator: (prop: string) =>
        ['upper-right', 'upper-left', 'bottom-right', 'bottom-left'].includes(
          prop
        ),
    },
    background: {
      type: String,
      default: 'is-background-info',
    },
  },
  setup(props) {
    const backgroundClass = computed(() => {
      switch (props.background) {
        case 'success':
          return 'bg-green-500';
        case 'danger':
          return 'bg-red-500';
        case 'info':
        default:
          return 'bg-primary-2 dark:bg-primary-1';
      }
    });
    const positionClass = computed(() => {
      switch (props.position) {
        case 'upper-left':
          return 'top-[92px] left-0';
        case 'bottom-right':
          return 'bottom-[92px] right-0';
        case 'bottom-left':
          return 'bottom-[92px] left-0';
        case 'upper-right':
        default:
          return 'top-[92px] right-0';
      }
    });

    return { backgroundClass, positionClass };
  },
});
</script>
